import {
  Autocomplete,
  Box,
  darken,
  Grid,
  lighten,
  styled,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import PageRoutes, { APIRoutes } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import HttpService from "../../../hooks/Https-services";
import useConfig from "../../../hooks/useConfig";
import GameSummaryTable from "./GameSummaryTable";
import GameSummarySettings from "./GameSummarySettings";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import momentTimezone from "moment-timezone";
import { endOfWeek } from "date-fns";
import endOfYear from "date-fns/endOfYear";
import addDays from "date-fns/addDays";
import endOfMonth from "date-fns/endOfMonth";
import startOfWeek from "date-fns/startOfWeek";
import startOfYear from "date-fns/startOfYear";
import startOfMonth from "date-fns/startOfMonth";
const userTimeZone = momentTimezone.tz.guess();
export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const GroupHeader = styled("div")(({ theme }: any) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled("ul")({
  padding: 0,
});
export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const ListOfGameSummary = () => {
  const [listOfGameSummary, setListOfGameSummary] = useState<any>([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [channelOption, setChannelOption] = useState<any>([]);
  const [pageData, setPageData] = React.useState({
    page: 0,
    total_entries: 0,
    limit: 5,
  });
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setPage(0);
    setValue(newValue);
  };
  const [filters, setFilters] = React.useState({
    status: "",
    channel: "",
    team: "",
    start_date: "",
    end_date: "",
  });
  const navigate = useNavigate();
  const configData = useConfig();
  const [teamOption, setTeamOption] = useState<any>([]);
  const FetchChannels = async () => {
    try {
      const result = await HttpService.getapi(
        APIRoutes.ChannelOption.replace(":id", configData.customer)
      );

      setChannelOption(result.data.data);
    } catch (error) {}
  };

  const FetchTeams = async (channel_id: any) => {
    try {
      const team: {
        label: any;
        team_id: any;
        customer?: any;
        team_description: any;
        team_short_name: any;
      }[] = [];

      if (channel_id != 0 || !channel_id) {
        const result = await HttpService.getapi(
          APIRoutes.Team.replace(":id", channel_id || "").replace(
            ":customer",
            configData.customer
          )
        );
        result.data.data?.forEach((element: any) => {
          const temp = {
            label: `${element?.team_name} ${element?.team_mascot}`,
            team_id: element.team_id,
            team_description: element.team_description,
            team_short_name: element.team_short_name,
          };
          if (element.team_description) {
            temp.label = temp.label + " (" + element.team_description + ")";
          }
          team.push(temp);
        });
      }

      setTeamOption(team);
    } catch (error) {
    } finally {
    }
  };
  const options = teamOption?.map((option: any) => {
    return {
      firstLetter: option.customer == 0 ? "My Favorites" : "Teams",
      ...option,
    };
  });
  const GetGameSummary = useCallback(async () => {
    try {
      const params: any = {
        isActive: value === 0 ? true : value === 1 ? false : true,
        page: page + 1,
        limit: rowsPerPage,
      };
      if (filters.status) {
        params.gameStatus = filters.status;
      }
      if (filters.channel) {
        params.channelId = filters.channel;
      }
      if (filters.team) {
        params.teamId = filters.team;
      }
      if (filters.start_date && filters.end_date) {
        const startDate = filters?.start_date
          ? momentTimezone
              .tz(
                `${filters?.start_date} 00:00:00`,
                "YYYY-MM-DD HH:mm:ss.SSSSSS Z",
                userTimeZone
              )
              .tz("America/New_York")
              .format("YYYY-MM-DD hh:mm A")
          : "";
        const endDate = filters?.end_date
          ? momentTimezone
              .tz(
                `${filters?.end_date} 23:59:59`,
                "YYYY-MM-DD HH:mm:ss.SSSSSS Z",
                userTimeZone
              )
              .tz("America/New_York")
              .format("YYYY-MM-DD hh:mm A")
          : "";

        params.startDate = startDate;
        params.endDate = endDate;
      }
      const res = await HttpService.get(
        `${APIRoutes.GetGameSummaryAdmin}?${new URLSearchParams(
          params
        ).toString()}`
      );
      setListOfGameSummary(res?.data?.data?.data);
      const data = res?.data?.data;
      setPageData({
        ...pageData,
        page: data.page,
        limit: data.limit,
        total_entries: data.count,
      });
    } catch (error) {
      console.error("Error fetching game summaries:", error);
    }
  }, [value, page, rowsPerPage, filters]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const predefinedRanges: any = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },

    {
      label: "This week",
      value: [startOfWeek(new Date()), addDays(new Date(), 6)],
      placement: "left",
    },

    {
      label: "This month",
      value: [startOfMonth(new Date()), new Date()],
      placement: "left",
    },

    {
      label: "This year",
      value: [startOfYear(new Date()), new Date()],
      placement: "left",
    },
  ];

  useEffect(() => {
    GetGameSummary();
  }, [GetGameSummary]);
  useEffect(() => {
    FetchChannels();
    FetchTeams(0);
  }, []);
  const handleChageStatus = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setFilters({
      ...filters,
      [name]: value,
    });
  };
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", py: 2 }}>
        <Typography variant="h3">Game Summaries</Typography>
      </Box>
      <Box>
        <Tabs value={value} onChange={handleChange} sx={{ px: 3 }}>
          <Tab label="Available" {...a11yProps(0)} />
          <Tab label="Trash" {...a11yProps(1)} />
        </Tabs>
        <Grid container sx={{ px: 2, pt: 2 }} spacing={2}>
          <Grid item xs={12} md={4}>
            <label className="select-wrapper">
              <span>Status </span>
              <select
                className="custom-select"
                value={filters.status}
                name="status"
                onChange={(event: any) => handleChageStatus(event)}
                defaultValue={filters.status}
              >
                <option value="">Select All</option>
                <option value="LIVE">Live and Upcoming Events </option>
                <option value={"VOD"}>On Demand</option>
              </select>
            </label>
          </Grid>
          <Grid item xs={12} md={4}>
            <label className="select-wrapper">
              <span> Channel </span>
              <select
                value={filters.channel}
                className="custom-select"
                name="channel"
                onChange={(event: any) => {
                  handleChageStatus(event);
                  FetchTeams(event.target.value);
                }}
                defaultValue={filters.channel}
              >
                <option value="">Select All</option>
                {channelOption
                  ?.sort((a: any, b: any) =>
                    a?.channel_weight < b?.channel_weight ? -1 : 1
                  )
                  .map((option: any) => (
                    <option value={option.channel_id}>
                      {option?.channel_name}
                    </option>
                  ))}
              </select>
            </label>
          </Grid>
          <Grid item xs={12} md={4}>
            {process.env.REACT_APP_DO_NOT_SHOW_TEAM !== "true" && (
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                getOptionLabel={(option) => option.label}
                options={options}
                groupBy={(option) => option.firstLetter}
                onChange={(event: any, value: any) => {
                  const eventData = {
                    target: {
                      value: value?.team_id,
                      name: "team",
                    },
                  };
                  handleChageStatus(eventData);
                }}
                size="small"
                renderOption={(props, option) => (
                  <Box component="li" {...props} key={option?.team_id}>
                    <Typography
                      variant="body1"
                      sx={{ fontStyle: "normal", textTransform: "none" }}
                    >
                      {" "}
                      {option?.label}
                    </Typography>
                  </Box>
                )}
                sx={{
                  width: 1,
                  background: "white",
                  fieldset: {
                    borderColor: "#959799",
                  },
                }}
                renderGroup={(params) => (
                  <li key={params.key}>
                    <GroupHeader>{params.group}</GroupHeader>
                    <GroupItems>{params.children}</GroupItems>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Team"
                    sx={{
                      borderColor: "#959799",
                      input: { height: "25px" },
                    }}
                  />
                )}
                className=""
              />
            )}
          </Grid>
          <Grid item xs={12} md={4}>
            <DateRangePicker
              className="datepicker"
              // size="lg"
              block
              showOneCalendar
              style={{ width: "100%" }}
              ranges={predefinedRanges}
              onChange={(value: any) => {
                if (value) {
                  setFilters({
                    ...filters,
                    start_date: moment(value[0]).format("YYYY-MM-DD"),
                    end_date: moment(value[1]).format("YYYY-MM-DD"),
                  });
                  setPage(0);
                } else {
                  setFilters({
                    ...filters,
                    start_date: "",
                    end_date: "",
                  });
                  setPage(0);
                }
              }}
              placeholder="Select date range"
            />
          </Grid>
        </Grid>
        <TabPanel value={value} index={0}>
          <GameSummaryTable
            listOfGameSummary={listOfGameSummary}
            pageData={pageData}
            GetGameSummary={GetGameSummary}
            page={page}
            value={value}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <GameSummaryTable
            pageData={pageData}
            page={page}
            value={value}
            rowsPerPage={rowsPerPage}
            listOfGameSummary={listOfGameSummary}
            GetGameSummary={GetGameSummary}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default ListOfGameSummary;
